export const creator_KP72BX3T = {
    custom_button_label: {
      recurring: 'View plans',
      recurring_single_plan: 'View plans',
    }
  };